import { Component } from 'react';
import { Button } from 'react-bootstrap';
import './SupportButton.css';
import { connect } from "react-redux";
import config from "../../config/config";
import WhatsappModal from '../../components/whatsapp_modal/WhatsappModal';


class SupportButton extends Component{
    constructor(props) {
        super(props);
        this.state = {
            showWhatsappModal: false,
        }
    }

    handleClickSupportButton = () => {
        this.setState({showWhatsappModal: true})
    }

    handleCloseWhatsappModal = () => {
        this.setState({showWhatsappModal: false})
    }

    render () {
        const { showWhatsappModal } = this.state;
        const { stepInfo } = this.props;

        if (!stepInfo.company_id || !config.directCustomerServiceCompaniesIds.includes(stepInfo.company_id)) {
            return null;
        }

        return (
            <div>
                <Button
                    className='support-button'
                    onClick={this.handleClickSupportButton}
                >
                    Soporte
                </Button>
                <WhatsappModal
                    show={showWhatsappModal}
                    handleClose={this.handleCloseWhatsappModal}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};


export default connect(mapStateToProps, mapDispatchToProps)(SupportButton);
